import { Box } from '@mui/material';
import { HTMLAttributes, forwardRef } from 'react';

export const InnerElementType = forwardRef<
  HTMLUListElement,
  HTMLAttributes<HTMLUListElement>
>((props, ref) => {
  return (
    <Box
      component="ul"
      ref={ref}
      style={{ ...props.style, margin: 0, padding: 0 }}
    >
      {props.children}
    </Box>
  );
});
